module.exports = ".switch {\n    -webkit-transform-origin: center;\n            transform-origin: center;\n    -webkit-transition-timing-function: ease;\n            transition-timing-function: ease;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    cursor: pointer;\n}\n\n.title {\n    font-family:'Arial';\n    font-size:0.7em;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/switch/switch.component.css
// module id = ./src/app/switch/switch.component.css
// module chunks = main